<div *ngIf="showDevComments" class="dev-comment">src\app\landowner\components\lease-season-grid\lease-season-grid.component.html</div>

<div *ngIf="!hideIfEmpty || (hideIfEmpty && leaseSeasons.length > 0)">
  <div class="title text-center" *ngIf="title">
    {{ title }}
  </div>

  <div class="thin-border">
    <!--Table-->
    <table class="adminTable">
      <!--Table head-->
      <thead>
        <tr>
          <!-- Reserved column for action links/buttons -->
          <th></th>

          <th *ngIf="contextType === LeaseSeasonGridContextType.Listing">ID</th>

          <th *ngIf="contextType === LeaseSeasonGridContextType.Listing">Annual Lease</th>

          <th>Name</th>
          <th *ngIf="showDescription">Description</th>

          <th>Start Date</th>
          <th>End Date</th>

          <th *ngIf="showReproductionMethod">Reproduction Method</th>

          <!-- Reserved column for action links/buttons -->
          <th></th>
        </tr>
      </thead>
      <!--Table head-->
      <!--Table body-->
      <tbody *ngIf="leaseSeasons && !retrieving">
        <tr *ngFor="let r of leaseSeasons" (click)="onRowClick(r)">
          <td>
            <!-- https://fontawesome.com/v4.7.0/examples/ -->

            <!-- class="featureless"
          [popover]="'Season conflicts with other seasons on this listing.'"
          popover-trigger="focus"
          [popoverTitle]="'Season Conflict'"
          [outsideClick]="true"
          placement="auto" -->

            <span *ngIf="r.hasConflict">
              <i *ngIf="r.hasConflict" class="fa fa-exclamation-triangle fa-lg" aria-hidden="true" title="Season Conflict!"></i>
            </span>
          </td>

          <td class="lease-id-cell" *ngIf="contextType === LeaseSeasonGridContextType.Listing">
            <!-- <secure-id-copy [label]="''" [value]="r.annualLeaseId"> </secure-id-copy> -->

            {{ r.annualLeaseId }}
          </td>

          <td *ngIf="contextType === LeaseSeasonGridContextType.Listing">{{ r.annualLeaseName }}</td>

          <td class="lease-season-season-name-cell">
            {{ r.name }}

            <oapopover *ngIf="r.description" [title]="r.name" [content]="r.description"></oapopover>
          </td>
          <td *ngIf="showDescription">{{ r.description }}</td>

          <td>{{ r.startDateTime | date: "shortDate" }}</td>
          <td>{{ r.endDateTime | date: "shortDate" }}</td>

          <td *ngIf="showReproductionMethod">
            {{ r.reproductionMethod }}
            <!-- <oapopover [title]="'Reproduction Description'" [content]="r.reproductionDescription"></oapopover> -->
          </td>

          <!-- Reserved column for action links/buttons -->
          <td>
            <ng-container *ngIf="contextType === LeaseSeasonGridContextType.Lease">
              <div class="edit-row-link" [ngClass]="{ 'link-disabled': !r.canEdit, link: r.canEdit }" (click)="onEditClick(r)">Edit</div>

              <div class="delete-row-link" [ngClass]="{ 'link-disabled': !r.canDelete, link: r.canDelete }" (click)="onDeleteClick(r)">
                Delete
              </div>
            </ng-container>
          </td>
        </tr>

        <!-- Dummy row to hold the Create link -->
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td *ngIf="showDescription">
            <!-- Keeps the reserved column in the right place when showDescription is true -->
          </td>
          <td *ngIf="showReproductionMethod"></td>

          <!-- Reserved column for action links/buttons -->
          <td>
            <ng-container *ngIf="contextType === LeaseSeasonGridContextType.Lease">
              <div class="link" (click)="onCreateClick()">Create</div>
            </ng-container>
          </td>
        </tr>
      </tbody>
      <!--Table body-->
    </table>
  </div>
</div>
<!-- 
(cancel)="onLeaseSeasonFormCancel()"
  (save)="onLeaseSeasonFormSave($event)" -->

<spinner *ngIf="retrieving" messageRelativePosition="bottom" [message]="'Loading Lease Seasons...'"> </spinner>

<!--

   -->
<ng-template #leaseSeasonFormModal style="top: 20px" let-modal>
  <div class="modal-header">
    <div class="title text-center" *ngIf="selectedLeaseSeason && selectedLeaseSeason.id > 0">Modify Season</div>

    <div class="title text-center" *ngIf="selectedLeaseSeason && selectedLeaseSeason.id === 0">Create Season</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <lease-season-form
      [showTitle]="false"
      [value]="selectedLeaseSeason"
      (save)="onSaveLeaseSeasonClick($event)"
      (cancel)="onCancelLeaseSeasonClick()"
    >
    </lease-season-form>
  </div>
</ng-template>
